<div *ngIf="account || showDetailUser == true" id="userDetail">
	<section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
		<section class="container professional-manager-account-details">
            <section class="template-section-title">
				<div class="title-container">
					<h1>Professional's Clients</h1>
				</div>
            </section>
            
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col">First Name</th>
                            <th scope="col">Last name</th>
                            <th scope="col">Email Address</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let account of account.licenses">
                            <td *ngIf="account.firstName">{{account.firstName}}</td>
                            <td *ngIf="account.lastName">{{account.lastName}}</td>
                            <td *ngIf="account.email">{{account.email}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
            <input type="button" class="btn btn-primary back-btn" value="Back" (click)="goBack()">
        </section>
    </section>
</div>
    
    
    
